// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavBar_NavBar__5idnY {
    background-color: #ffffff;
    color: black;
  }

.NavBar_NavLink__hqIs8 {
  padding: 2px;
  font-size: 12px;
  display: flex;
  align-items: center;
}

a.NavBar_NavLink__hqIs8{
  margin-top: -3px !important;
}

.NavBar_NavLink__hqIs8:active p {
  color: red;
}

.NavBar_nav__ZcBNw a.NavBar_active__uowKp {
  color: #fff;
  background: #7600dc;
}
.NavBar_nav__ZcBNw a.NavBar_inactive__Cq5TB {
  font-style: italic;
}

/* .NavLink:active i {
  color: red;
}

.NavLink:active {
  color: red;
} */

.NavBar_DropLink__G485P {
  color: black;
}

.NavBar_HomeLink__gsz8M {
  color: #555555,
}

.NavBar_HomeLink__gsz8M i:hover {
  color: #555555,
}

/* .Active i {
  color: #2142b2;
}

.Active {
  color: #2142b2;
} */

Title {
  color: #000;
}

.NavBar_NavLink__hqIs8 i {
  color: rgb(41, 180, 180);
  font-size: 1em !important;
}

/* my nav */

/* .NavBar {
    background-color: #ffffff;
    color: black;
  }

.NavLink {
  padding: 2px;
  font-size: 12px;
}

.NavLink:hover {
padding: 2px;
color: #000
}

.NavLink:active p {
  color: red;
}

.nav a.active {
  color: #fff;
  background: #7600dc;
}
.nav a.inactive {
  font-style: italic;
}

.DropLink {
  color: black;
}

.DropLink:hover {
  color: #000;
}

.Active i {
color: rgb(3, 81, 81);
}

.Active {
color: rgb(3, 81, 81);
}

Title {
  color: #000;
}

.NavLink i {
  color: rgb(41, 180, 180);
} */`, "",{"version":3,"sources":["webpack://./src/styles/NavBar.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;EACd;;AAEF;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA;;;;;;GAMG;;AAEH;EACE,YAAY;AACd;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;;;;;GAMG;;AAEH;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA,WAAW;;AAEX;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAiDG","sourcesContent":[".NavBar {\n    background-color: #ffffff;\n    color: black;\n  }\n\n.NavLink {\n  padding: 2px;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n}\n\na.NavLink{\n  margin-top: -3px !important;\n}\n\n.NavLink:active p {\n  color: red;\n}\n\n.nav a.active {\n  color: #fff;\n  background: #7600dc;\n}\n.nav a.inactive {\n  font-style: italic;\n}\n\n/* .NavLink:active i {\n  color: red;\n}\n\n.NavLink:active {\n  color: red;\n} */\n\n.DropLink {\n  color: black;\n}\n\n.HomeLink {\n  color: #555555,\n}\n\n.HomeLink i:hover {\n  color: #555555,\n}\n\n/* .Active i {\n  color: #2142b2;\n}\n\n.Active {\n  color: #2142b2;\n} */\n\nTitle {\n  color: #000;\n}\n\n.NavLink i {\n  color: rgb(41, 180, 180);\n  font-size: 1em !important;\n}\n\n/* my nav */\n\n/* .NavBar {\n    background-color: #ffffff;\n    color: black;\n  }\n\n.NavLink {\n  padding: 2px;\n  font-size: 12px;\n}\n\n.NavLink:hover {\npadding: 2px;\ncolor: #000\n}\n\n.NavLink:active p {\n  color: red;\n}\n\n.nav a.active {\n  color: #fff;\n  background: #7600dc;\n}\n.nav a.inactive {\n  font-style: italic;\n}\n\n.DropLink {\n  color: black;\n}\n\n.DropLink:hover {\n  color: #000;\n}\n\n.Active i {\ncolor: rgb(3, 81, 81);\n}\n\n.Active {\ncolor: rgb(3, 81, 81);\n}\n\nTitle {\n  color: #000;\n}\n\n.NavLink i {\n  color: rgb(41, 180, 180);\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NavBar": `NavBar_NavBar__5idnY`,
	"NavLink": `NavBar_NavLink__hqIs8`,
	"nav": `NavBar_nav__ZcBNw`,
	"active": `NavBar_active__uowKp`,
	"inactive": `NavBar_inactive__Cq5TB`,
	"DropLink": `NavBar_DropLink__G485P`,
	"HomeLink": `NavBar_HomeLink__gsz8M`
};
export default ___CSS_LOADER_EXPORT___;
